var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader",class:_vm.size},[_c('div',{staticClass:"preloader",class:_vm.color},[_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div')])])
}
var staticRenderFns = []

export { render, staticRenderFns }